export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil-feel-the-rush-of-e-foiling.c57fbac9.png";